import React from 'react';
import { Outlet, Navigate, useLocation, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminDocTree from './AdminDocTree';
import './Admin.css';

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const publicAuthPaths = ['/admin/login', '/admin/forgot-password', '/admin/reset-password'];
  const isPublicAuthPage = publicAuthPaths.includes(location.pathname);

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  if (loading) {
    return (
      <div className="admin-area admin-loading">
        <p>Loading…</p>
      </div>
    );
  }

  if (!user && !isPublicAuthPage) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (isPublicAuthPage) {
    return (
      <div className="admin-area admin-area-auth-only">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="admin-area admin-area-with-tree">
      <AdminDocTree />
      <header className="admin-header">
        <div className="admin-header-inner">
          <Link to="/admin" className="admin-logo">Doc Admin</Link>
          <nav className="admin-nav">
            <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>Dashboard</Link>
            <Link to="/admin/categories" className={location.pathname.startsWith('/admin/categories') ? 'active' : ''}>Categories</Link>
            <Link to="/admin/applications" className={location.pathname.startsWith('/admin/applications') ? 'active' : ''}>Applications</Link>
            <Link to="/admin/articles" className={location.pathname.startsWith('/admin/articles') ? 'active' : ''}>Articles</Link>
            <Link to="/admin/quick-links" className={location.pathname.startsWith('/admin/quick-links') ? 'active' : ''}>Quick Links</Link>
            <span className="admin-user">{user.email}</span>
            <button type="button" className="admin-logout" onClick={handleLogout}>Logout</button>
          </nav>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
